import { render, staticRenderFns } from "./LeaderboardTeamListComponent.vue?vue&type=template&id=fffd24fa&scoped=true&"
import script from "./LeaderboardTeamListComponent.vue?vue&type=script&lang=ts&"
export * from "./LeaderboardTeamListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LeaderboardTeamListComponent.vue?vue&type=style&index=0&id=fffd24fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffd24fa",
  null
  
)

export default component.exports